import { useMediaQuery, Typography, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props {
  isLoading?: boolean;
  title: string;
  subtitle?: string | undefined;
}

const MainContentHeader = (props: Props) => {
  const { isLoading = false, title, subtitle = '' } = props;
  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Typography variant={isXS ? 'h6' : 'h5'} sx={{ fontWeight: 700 }}>
        {!isLoading && <>{title}</>}
        {isLoading && <>&nbsp;</>}
      </Typography>
      {subtitle && (
        <Typography variant='subtitle2' color='textSecondary' gutterBottom>
          {!isLoading && <>{subtitle}</>}
          {isLoading && <Skeleton sx={{ maxWidth: '50vw' }} />}
        </Typography>
      )}
      {/* {!isXS && <br />} */}
    </>
  );
};

export default MainContentHeader;
